import React from "react";
import rightImg from "../../assets/images/satisfyingRight.png";
import soSatisfy from "../../assets/images/Oh So Satisfying.png";
import imgRight from "../../assets/images/right-satisfyimg-removebg-preview.png";
import imgLeft from "../../assets/images/left-satisfyimg-removebg-preview.png";
import { useNavigate } from "react-router-dom";

const CustomerSatisfying = () => {
  const history = useNavigate();
  return (
    <section id="customerSatisfying">
       <img src={imgLeft} className="Satisfy-imgleft" />
        <img src={imgRight} className="Satisfy-imgright" />
      <div className="wrapper customer-flex">
        {/* LEFT IMAGE */}
        <div className="customer-image">
          <img src={rightImg} alt="Customer Satisfying Food" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="customer-content">
          <span className="tagline">
            <img src={soSatisfy} className="soSatisfy-img" />
          </span>

          <h2>
            OUR GO-TO GRINDER <br /> FOR GENERATIONS
          </h2>

          <p>
            Our classic Italian grinder is as good as it gets. Freshly baked bread layered with salami, genoa and ham, finished with
            provolone, crisp lettuce and ripe tomato.Add your choice of condiment and taste why this classic is always a customer favorite.
          </p>

          <button className="primary-btn" onClick={() => history('/menu?section=coldgrinders&item=italiancoldgrinder')}>ORDER NOW</button>
        </div>
      </div>
    </section>
  );
};

export default CustomerSatisfying;
